import { render, staticRenderFns } from "./bigCustClueReport.vue?vue&type=template&id=711bff35&scoped=true&"
import script from "./bigCustClueReport.vue?vue&type=script&lang=js&"
export * from "./bigCustClueReport.vue?vue&type=script&lang=js&"
import style0 from "./bigCustClueReport.vue?vue&type=style&index=0&id=711bff35&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711bff35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711bff35')) {
      api.createRecord('711bff35', component.options)
    } else {
      api.reload('711bff35', component.options)
    }
    module.hot.accept("./bigCustClueReport.vue?vue&type=template&id=711bff35&scoped=true&", function () {
      api.rerender('711bff35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/report/bigCustClueReport/bigCustClueReport.vue"
export default component.exports